<template>
  <div>
    <v-form ref="schoolRateForms">
      <v-card flat class="pt-1">
        <h3 class="text-center mb-5">Add Your Rates</h3>
        <div class="row">
          <div class="col-md-12 form-group">
            <v-text-field
              outlined
              dense
              label="What is your hourly lesson rate?"
              type="text"
              :rules="fieldRules"
              v-model="lessonRate"
              name="lessonRate"
              required
            />
          </div>
          <div class="col-md-12 form-group">
            <v-text-field
              outlined
              dense
              label="What is your car rental rate for roadtest?"
              type="text"
              :rules="fieldRules"
              v-model="carRentRate"
              name="carRentRate"
              required
            />
          </div>
          <div class="col-md-12 form-group">
            <v-text-field
              outlined
              dense
              label="Car rental + one hour lesson prior to road test"
              type="text"
              :rules="fieldRules"
              v-model="roadTestRate"
              name="roadTestRate"
              required
            />
          </div>
          <div class="col-md-12 form-group">
            <v-text-field
              outlined
              dense
              label="Discounted one hour rate for course students"
              type="text"
              :rules="fieldRules"
              v-model="schoolRate"
              name="schoolRate"
              required
            />
          </div>
        </div>
        <v-row no-gutters style="justify-content: space-between">
          <v-col
            cols="auto"
            style="
              justify-content: space-between;
              display: flex;
              width: 100%;
              align-items: center;
            "
          >
            <div>
              <input type="checkbox" @change="toggleModal" /> Agree Employment
              Contract
            </div>
            <v-btn
              :disabled="!contractUrl"
              ref="signupFormSubmitButton"
              color="primary"
              @click="submit"
              >Submit</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-form>
    <v-dialog ref="dynamicContent" v-model="dialog" max-width="600" persistent>
      <v-card id="modalContent">
        <v-card-title class="text-h5">EMPLOYMENT CONTRACT</v-card-title>
        <v-card-text>
          This Employment Contract is entered into between TheDriverX, and
          Driving Instructor collectively referred to as the "Parties".
          <h3>1. Engagement</h3>
          <p>
            1.1 Engagement Description: The Employee is engaged as a
            subcontractor to provide driving instruction services to clients of
            TheDriverX. The Employee shall perform their duties diligently and
            in a professional manner, adhering to the standards set by the
            Employer.
          </p>
          <br />
          <p>
            1.2 Scope of Work: The Employee shall provide driving instruction
            services in accordance with the Employer's guidelines and policies.
            The specific tasks, schedules, and locations shall be determined by
            the Employer and communicated to the Employee in a timely manner.
          </p>
          <br />
          <p>
            1.3 Independent Contractor: The Employee acknowledges and agrees
            that they are engaged as a subcontractor and not as an employee, and
            that this Contract does not create an employer-employee relationship
            between the Parties.
          </p>
          <h3>2. Compensation</h3>
          <p>
            2.1 Payment Terms: The Employee shall be compensated based on the
            agreed-upon rate for each driving instruction session completed. The
            payment terms and rates shall be communicated to the Employee by the
            Employer. The Employee shall provide accurate and timely invoices
            for the services rendered.
          </p>
          <br />
          <p>
            2.2 Taxes and Deductions: As an independent subcontractor, the
            Employee is responsible for all taxes, social security
            contributions, and other deductions arising from the compensation
            received under this Contract. The Employer shall not be responsible
            for any deductions or withholdings on behalf of the Employee.
          </p>
          <h3>3. Confidentiality and Non-Disclosure</h3>
          <p>
            3.1 Confidential Information: During the course of their engagement,
            the Employee may have access to confidential and proprietary
            information of the Employer, its clients, or students. The Employee
            agrees to maintain the confidentiality of such information and not
            to disclose it to any third party, except as required by law or with
            the prior written consent of the Employer.
          </p>
          <h3>4. Validity of Information</h3>
          <p>
            4.1 Validity of Information Provided: The Employee represents and
            warrants that all information, certifications, licenses, and
            documentation provided to the Employer regarding their
            qualifications and ability to provide driving instruction are true,
            accurate, and valid. The Employer reserves the right to verify the
            information provided, and if the Employer deems any information to
            be false, inaccurate, or invalid, the Employer may immediately
            terminate this Contract.
          </p>
          <br />
          <h3>5. Term and Termination</h3>
          <p>
            5.1 Term: This Contract shall commence on the Effective Date and
            shall continue until terminated by either Party in accordance with
            the termination provisions set forth herein.
          </p>
          <br />
          <p>
            5.2 Termination for Convenience: Either Party may terminate this
            Contract at any time, with or without cause, by providing [Notice
            Period] written notice to the other Party.
          </p>
          <br />
          <p>
            5.3 Termination for Breach: Either Party may terminate this Contract
            immediately upon written notice if the other Party commits a
            material breach of its obligations under this Contract and fails to
            remedy such breach within [Cure Period] days after receiving written
            notice specifying the breach.
          </p>
          <h3>6. Governing Law and Dispute Resolution</h3>
          <p>
            6.1 Governing Law: This Contract shall be governed by and construed
            in accordance with the laws of the province of Ontario, Canada.
          </p>
          <br />
          <p>
            6.2 Jurisdiction: Any disputes arising out of or in connection with
            this Contract shall be subject to the exclusive jurisdiction of the
            courts of the province of Ontario, Canada.
          </p>
          <h3>7. Entire Agreement</h3>
          <p>
            7.1 Entire Agreement: This Contract constitutes the entire agreement
            between the Parties and supersedes all prior discussions,
            negotiations, and agreements, whether written or oral, relating to
            the subject matter hereof.
          </p>
          <br />
          <div class="sigBox">
            <div>
              <p>
                Instructor: {{ this.instructorData.firstName }}
                {{ this.instructorData.lastName }}
              </p>
              <p>Employer: Driverx School </p>
            </div>

            <!-- Signature pad -->
            <div>
              <p style="margin: 0; text-align: center">Signature here....</p>
              <VueSignaturePad
                style="
                  z-index: 100000;
                  border: 3px dotted black;
                  margin-bottom: 2px;
                  width: 314px;
                  height: 140px;
                "
                id="signature"
                ref="signaturePad"
                height="130px"
                width="300px"
                :options="{
                  backgroundColor: '#fff', // Adjusted to a lighter color
                  penColor: '#000',
                  onBegin: () => {
                    $refs.signaturePad.resizeCanvas();
                    this.isSigned = true; // Set isSigned to true when the user begins signing
                  },
                  onEnd: () => {
                    this.checkSignature();
                  },
                }"
              ></VueSignaturePad>
            </div>
          </div>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
      <div class="modalBox">
        <v-btn
          :disabled="!isSigned"
          ref="signupFormSubmitButton"
          color="primary"
          @click="undo"
          >Undo Signature</v-btn
        >
        <v-btn
          :disabled="!isSigned || isSignatureEmpty"
          ref="agreeButton"
          color="primary"
          @click="generatePDF"
          >Agree</v-btn
        >
      </div>
    </v-dialog>
  </div>
</template>

<script>
import validationRules from '@/validation-rules'
import Parse from 'parse'
import { mapActions } from 'vuex'
import { customValidate } from '../../Helper'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { VueSignaturePad } from 'vue-signature-pad'

export default {
  name: 'SchoolRates',
  components: {
    VueSignaturePad
  },
  props: {
    instructorData: {
      type: Object,
      defaults: {}
    }
  },
  data () {
    return {
      lessonRate: '',
      carRentRate: '',
      roadTestRate: '',
      schoolRate: '',
      dialog: false,
      username: '',
      isSigned: false,
      contractUrl: '',
      isSignatureEmpty: true,
      ...validationRules
    }
  },
  created () {
    this.username = `${this.instructorData.firstName} ${this.instructorData.lastName}`
  },
  computed: {
    isChecked () {
      return !!this.contractUrl
    }
  },
  methods: {
    ...mapActions(['toggleDialog']),

    async submit (e) {
      console.log('Submitted')
      e.preventDefault()
      const validation = this.$refs.schoolRateForms.validate()
      const elements = this.$refs.schoolRateForms.$el.elements
      if (
        customValidate(elements) &&
        Object.keys(this.instructorData).length > 0
      ) {
        this.$refs.signupFormSubmitButton.$el.innerHTML = 'Please Wait ...'
        const { email } = this.instructorData
        const User = new Parse.User()
        const query = new Parse.Query(User)
        query.equalTo('email', email)
        await query.find({ useMasterKey: true }).then(async (result) => {
          if (result.length === 0) {
            await this.createUser()
          } else {
            this.toggleDialog({
              status: true,
              title: 'Warning',
              message: 'Account already registered'
            })
          }
        })
        /* this.$emit('moveToLastStep', { step: 7 }) */
      }
    },
    async createUser () {
      const {
        userType,
        firstName,
        lastName,
        birthDate,
        email,
        phone,
        password,
        phoneVerify,
        city,
        country,
        province,
        addressOne,
        addressTwo,
        postalCode,
        operateModel,
        instructorCityPlat,
        selectCities,
        drivingLicensePreview,
        instructorLicensePreview,
        schoolData,
        schoolId
      } = this.instructorData
      const citiesPlats = []
      instructorCityPlat.map((row, index) => {
        citiesPlats.push({
          city: row.cityName,
          fileUrl: row.fileUrl
        })
      })
      console.log(citiesPlats)
      const user = new Parse.User()
      user.set('firstName', firstName)
      user.set('lastName', lastName)
      user.set('username', email)
      user.set('password', password)
      user.set('customEmail', email)
      user.set('email', email)
      user.set('phone', phone)
      user.set('phoneVerify', phoneVerify)
      user.set('tourFinished', false)
      user.set('addressOne', addressOne)
      user.set('addressTwo', addressTwo)
      user.set('postalCode', postalCode)
      /* user.set('location', [-79.5896218, 43.61181630000001]) */
      user.set('city', city)
      user.set('country', country)
      user.set('province', province)
      user.set('uploadLicence', drivingLicensePreview)
      user.set('uploadInstructorLicence', instructorLicensePreview)
      user.set('licenceNumber', '') /* in progress */
      user.set('independent', operateModel)
      user.set('citiesPlat', citiesPlats)
      user.set('instructorCities', selectCities)
      user.set('carPlateNumber', [])
      user.set('instructingPlateNumber', '')
      user.set('profileNotCompleted', false)
      user.set('booking_lesson', Number(this.lessonRate))
      user.set('rentcar_n_lesson', Number(this.carRentRate))
      user.set('roadtest_rent_car', Number(this.roadTestRate))
      user.set('packageAdded', true)
      user.set('school_rate', Number(this.schoolRate))
      user.set('dob', new Date(birthDate))
      user.set('contract', this.contractUrl)
      if (operateModel === true) {
        const { schoolName, schoolContactNumber, schoolEmail, schoolAddress } =
          schoolData
        user.set('schoolId', schoolId)
        user.set('school', {
          schoolName: schoolName,
          contactNo: schoolContactNumber,
          schoolEmail: schoolEmail,
          schoolAddress: schoolAddress
          /* addressTwo: addressTwo,
          city: schoolData.city,
          province: schoolData.province,
          postalCode: schoolData.postalCode,
          country: schoolData.country */
        })
      }
      if (userType === 'Instructor') {
        user.set('status', false)
      } else {
        user.set('status', true)
      }
      await user.signUp(null, { useMasterKey: true }).then(async () => {
        /* add user to mailchimp  */
        const cData = {
          firstName: firstName || '',
          lastName: lastName || '',
          email: email,
          phone: phone
        }

        await Parse.Cloud.run('addContactToMailChimp', cData).then(
          (results) => {
            console.log(results, 'MAILCHIMP')
          },
          (error) => {
            console.log(error)
          }
        )

        /* add user to mailchimp  */
        /** Add user to the user group */
        const data = {
          user: user.id,
          accountname: userType === 'Instructor' ? 'Instructor' : 'Student',
          admin: false
        }
        /** call the cloud function */
        await Parse.Cloud.run('addUserToRole', data).then(async () => {
          /** We don't want users to be logged in right now as they need to verify their email */
          /** Show success alert */
          console.log('Success')
          await this.createSchool(schoolData, user.id, schoolId, operateModel)
            .then((schoolId) => {
              console.log(schoolId, 'success')
            })
            .catch((error) => {
              console.log(error, 'Error')
            })

          var message =
            firstName +
            ' ' +
            lastName +
            ' just signed up as Instructor from the city of ' +
            selectCities +
            ' ,' +
            province
          // eslint-disable-next-line no-unused-expressions
          '. Contact number is ' + phone

          Parse.Cloud.run('sendSMS', { message: message }).then((result) => {
            console.log('SMS successful')
          })

          /** Send an email as well */
          const eData = {
            contact:
              'city of ' +
              selectCities +
              ', ' +
              province +
              ' and cell# ' +
              phone,
            type: 'Instructor',
            name: firstName + ' ' + lastName
          }
          /** call the cloud function */
          Parse.Cloud.run('newUserJoined', eData).then((result) => {
            console.log('Email successful')
          })

          Parse.User.logOut()
          console.log(schoolId, 'school Id')
          localStorage.setItem('regDone', true)
        })
        /** call the cloud function */
      })
    },
    async updateInstructorSchool (userId, schoolId) {
      console.log(userId, schoolId, 'User and School id loaded')

      return new Promise((resolve, reject) => {
        if (schoolId !== '' && userId !== '') {
          const InstructorSchools = Parse.Object.extend('InstructorSchools')
          const saveInstructorSchools = new InstructorSchools()
          /* setting schoolId for InstructorSchool associative Table */
          const SchoolClass = Parse.Object.extend('Schools')
          const schoolsPointerId = new SchoolClass()
          schoolsPointerId.id = schoolId
          saveInstructorSchools.set('schoolId', schoolsPointerId)
          /* setting schoolId for InstructorSchool associative Table */
          /* setting userId for InstructorSchool associative Table */
          var User = Parse.Object.extend('User')
          var UserPointerId = new User()
          UserPointerId.id = userId
          saveInstructorSchools.set('instructorId', UserPointerId)
          /* setting userId for InstructorSchool associative Table */
          saveInstructorSchools
            .save()
            .then(() => {
              this.instructorPackage(userId)
              this.$emit('moveToLastStep', true)
              this.$refs.signupFormSubmitButton.$el.innerHTML = 'Submit'
              resolve('Account create successfully..')
            })
            .catch((error) => {
              console.log(error, 'Error in InstructorSchool')
              reject(error)
            })
        }
      })
    },
    async createSchool (schoolData, userId, schoolId, operateModel) {
      return new Promise((reslove, reject) => {
        if (schoolId === '') {
          this.$emit('moveToLastStep', true)
          this.instructorPackage(userId)
          this.$refs.signupFormSubmit.$el.innerHTML = 'Submit'
          reslove('Account create successfully..')
        } else {
          /* driver x */
          this.updateInstructorSchool(userId, schoolId)
          reslove(schoolId)
        }
      })
    },
    instructorPackage (userId) {
      const InstructorPackages = Parse.Object.extend('InstructorPackages')
      const InstructorPackage = new InstructorPackages()
      var User = Parse.Object.extend('User')
      var UserPointerId = new User()
      UserPointerId.id = userId
      InstructorPackage.set('instructorId', UserPointerId)
      InstructorPackage.set('booking_lesson', Number(this.lessonRate))
      InstructorPackage.set('rentcar_n_lesson', Number(this.carRentRate))
      InstructorPackage.set('roadtest_rent_car', Number(this.roadTestRate))
      InstructorPackage.set('school_rate', Number(this.schoolRate))
      InstructorPackage.save()
    },

    toggleModal () {
      this.dialog = !this.dialog
    },

    generatePDF () {
      this.$refs.agreeButton.$el.innerHTML = 'Please wait ...'
      const pdf = new jsPDF()
      const content = document.getElementById('modalContent')
      const options = {
        margin: {
          top: 20,
          bottom: 20,
          left: 20,
          right: 20
        }
      }

      // Construct the PDF directly
      html2canvas(content, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL('image/jpeg', 1.0)

        // Split content into multiple pages if necessary
        const contentHeight = content.offsetHeight
        const pageHeight = pdf.internal.pageSize.getHeight()
        let yPos = 0
        let remainingHeight = contentHeight

        while (remainingHeight > 0) {
          const pageHeightAdjusted = Math.min(pageHeight, remainingHeight)
          const aspectRatio = canvas.width / canvas.height
          const adjustedWidth = pageHeightAdjusted * aspectRatio

          pdf.addImage(
            imgData,
            'JPEG',
            0,
            yPos,
            adjustedWidth,
            pageHeightAdjusted
          )

          remainingHeight -= pageHeightAdjusted
          yPos -= pageHeightAdjusted

          // if (remainingHeight > 0) {
          //   pdf.addPage();
          // }
        }

        // Convert the PDF to a Blob object
        const blob = pdf.output('blob')

        // Create a Parse File object from the Blob
        const timestamp = (new Date().getTime() / 1000).toFixed(0)
        const name = `employment_contract_${timestamp}.pdf`
        const parseFile = new Parse.File(name.toLowerCase(), blob)
        parseFile.addMetadata('tag', name.toLowerCase())
        parseFile.addTag('textTag', 'some-group-id')

        parseFile
          .save({
            progress: (value) => {
              this.progressValueIL = value * 100
            }
          })
          .then(async (res) => {
            console.log(res, parseFile?._url, 'then')
            this.contractUrl = parseFile?._url
            this.dialog = false
            // Reset button text
            this.$refs.agreeButton.$el.innerHTML = 'Agree'
          })
          .catch((error) => {
            console.log(error?.message, error.code, 'Error')
            // Reset button text
            this.$refs.agreeButton.$el.innerHTML = 'Agree'
          })
      })
    },

    checkSignature () {
      const signaturePad = this.$refs.signaturePad
      const isEmpty = signaturePad.isEmpty()
      this.isSignatureEmpty = isEmpty
    },

    undo () {
      this.$refs.signaturePad.undoSignature()
      this.checkSignature()
    },
    save () {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()

      alert('Open DevTools see the save data.')
      console.log(isEmpty)
      console.log(data)
    }
  }
}
</script>

<style scoped>
#signature canvas {
  height: 142px !important;
  width: 312px !important;
  border: 3px dotted #000 !important;
  background-color: aquamarine;
}

.sigBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
}
.modalBox {
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
  gap: 3px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
</style>
